import LocationsMultiselectInput from './LocationsMultiselectInput'

export default LocationsMultiselectInput
